import { Trans, useTranslation } from 'react-i18next';
import { useState } from 'react';
import { Dropdown, DropdownButton, ButtonGroup } from 'react-bootstrap';
import { Scrollbars } from 'react-custom-scrollbars-2';
import AddSlipBtn from './AddSlipBtn';
import ArrowIcon from '../../Common/ui-components/ArrowIcon';
import ClearAllHorseSelectionsButton from './ClearAllHorseSelectionsButton';

const renderThumb = ({ style, ...props }) => {
    const thumbStyle = {
        borderRadius: "3px",
        backgroundColor: "#D8D8D8"
    };
    return <div style={{ ...style, ...thumbStyle }} {...props} />;
};

const CustomScrollbars = props => (
    <Scrollbars
        renderThumbHorizontal={renderThumb}
        renderThumbVertical={renderThumb}
        autoHeight
        autoHeightMin={0}
        autoHeightMax={550}
        {...props}
    />
);

const TTQDropdownBtn=(props)=>{
    const { t } = useTranslation();
    const {title,items,onClickFunc,curSel}=props;
    const curVal=items.find((x,index) => index == curSel).val;
    return <>
        <DropdownButton
            as={ButtonGroup}
            key={`jkcAllup`}
            id={`jkcAllup`}
            variant="Formulas"
            className="dropdown-allup-formulas jkcAllup rc-tt-dropdown"
            title={<><span title={curVal}>{curVal}</span><ArrowIcon direction='down' size={24}/></>}
            align="end"
            disabled={items.length <= 0}
        >
            <Dropdown.Item className='rc-jtc-dropdown-header' eventKey="jkcAllupsub-header" value={t(props.title)} key="jkcAllupsub-header" >{props.title}</Dropdown.Item>
                <CustomScrollbars >
                    <div className="rc-jtc-dropdown-body">
                        {items.map((_cItem, _cIndex) => {
                            return <Dropdown.Item value={_cIndex} className="dropdown-item rc-jtc-dropdown-item" onClick={onClickFunc}>{_cItem.val}</Dropdown.Item>
                        })}
                    </div>
                </CustomScrollbars>
            </DropdownButton>
        </>
}

const TTQuickPick = (props) => {
    const { t, i18n } = useTranslation();
    const [ttqpSel, setTTQPSel] = useState(0);

    let ttqpMenuItem = [{ val: t('LB_RC_ODDS_TTRAN1'), chance: 2 },
    { val: t('LB_RC_ODDS_TTRAN2'), chance: 64 },
    { val: t('LB_RC_ODDS_TTRAN3'), chance: 27 },
    { val: t('LB_RC_ODDS_TTRAN4'), chance: 4 }];

    const handleClickTTQPMenu = (event) => {
        let value = event.target.getAttribute("value");
        setTTQPSel(value);
    }

    function TTQPDropdown(props) {
        return (props.show ?
            <div className="rc-tt-dropdown-menu">
                <div className="rc-tt-dropdown-header">{props.title}</div>
                <CustomScrollbars >
                    <div className="rc-tt-dropdown-body">
                        {ttqpMenuItem.map((_cItem, _cIndex) => {
                            return <a value={_cIndex} className="dropdown-item rc-tt-dropdown-item" onClick={props.onClickFunc}>{_cItem.val}</a>;
                        })}
                    </div>
                </CustomScrollbars>
            </div> : null);
    }

  return (
    <div className={`radio-row${props.mobile}`}>
        <div className="method-title-left-container">
            <TTQDropdownBtn title={t('LB_RC_ODDS_TTQP')} items={ttqpMenuItem} onClickFunc={(e) => { handleClickTTQPMenu(e ) }} curSel={ttqpSel} />
            <div className="TTQP-button-wrap" onClick={(e) => { props.handleRandomTTQP(ttqpSel) }} >
                <div className="ttqp-icon" ></div>
                <span className="TTQP-button-text">
                    <Trans
                        i18nKey="LB_RC_ODDS_TTQP_CLICK"
                        values={{
                            chance: ttqpMenuItem[ttqpSel].chance
                        }}
                        components={{ Span: <span /> }}
                    />
                </span>
            </div>
        </div>
        <div className="ttqp-addslip">
            {window.globalConfig.enableHRClearAllSelectionButton && (
                <ClearAllHorseSelectionsButton />
            )}
            <AddSlipBtn />
        </div>
    </div>);
}
export default TTQuickPick